<body>
    <p>All jobs have been successfully proceeded!</p>
    <button mat-dialog-close> Close </button>
</body>
